import { ReactNode } from 'react';
import Container from '../../containers/container';
import { Stack } from '../../layouts/stack.layout';

type HButtonGroupProps = {
  children: ReactNode;
  extensions?: string;
};

export function HButtonGroup(props: HButtonGroupProps) {
  return (
    <Container extensions={props.extensions || ''}>
      <Stack extensions="h-full" direction="horizontal" align="center" gap="sm">
        {props.children}
      </Stack>
    </Container>
  );
}
